import React from 'react'
import PanelSearchEmail from '../search/PanelSearchEmail'
import TableFinancial from './TableFinancial'

function PanelFinancialEmail({
  email,
}) {
  return (
    <PanelSearchEmail
      email={email}
      TableComponent={TableFinancial} />
  )
}

export default (PanelFinancialEmail)